// content/AIPosts/AIPostsTopicPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { Grid, Column, Button, TextInput, InlineNotification, Tile, Breadcrumb, BreadcrumbItem } from '@carbon/react';
import amplitude from './../../analytics/amplitude';
import { fetchSummaries, subscribeTopic } from './api';

const Card = ({ post, onOpen }) => {
  const to = `/posts/${post.topic}/${post.date}/${post.title_slug}`;
  return (
    <Tile style={{padding: 0, overflow:'hidden', borderRadius:12, display:'flex', flexDirection:'column'}}>
      {post.hero_url ? (
        <img
          src={post.hero_url}
          alt={post.title || post.title_slug}
          style={{ width:'100%', height:160, objectFit:'cover', cursor:'pointer' }}
          onClick={onOpen}
        />
      ) : (
        <div style={{ width:'100%', height:160, background:'#f4f4f4', cursor:'pointer' }} onClick={onOpen} />
      )}
      <div style={{ padding:12 }}>
        <RouterLink to={to} onClick={onOpen} style={{ textDecoration:'none' }}>
          <div style={{ fontWeight:600, marginBottom:6 }}>{post.title || post.title_slug.replace(/-/g,' ')}</div>
        </RouterLink>
        <div style={{ fontSize:12, opacity:0.7, marginBottom:6 }}>
          {post.date} • {post.model || '—'}
        </div>
        {post.summary && (
          <div style={{ fontSize:12, opacity:0.85, maxHeight:36, overflow:'hidden' }}>
            {post.summary}
          </div>
        )}
      </div>
    </Tile>
  );
};

const TopicBreadcrumbs = ({ topic, onBack }) => {
  const label = (topic || '').replace(/-/g, ' ');
  return (
    <nav aria-label="Breadcrumb" style={{ margin: '8px 0 12px' }}>
      <Breadcrumb noTrailingSlash>
        <BreadcrumbItem>
          <a href="/#/posts">AI Posts</a>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>{label || 'topic'}</BreadcrumbItem>
      </Breadcrumb>
      <div style={{ marginTop: 8 }}>
        <Button kind="ghost" size="sm" onClick={onBack}>← All topics</Button>
      </div>
    </nav>
  );
};

const AIPostsTopicPage = () => {
  const { topic } = useParams();
  const nav = useNavigate();
  const [posts, setPosts] = useState([]);
  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [status, setStatus] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const items = await fetchSummaries(topic, 30);
        setPosts(items);
        try { amplitude.track('View Topic', { topic, count: items.length }); } catch {}
      } catch (e) { setStatus({ kind: 'error', msg: String(e) }); }
    })();
  }, [topic]);

  const onSubscribe = async () => {
    try {
      await subscribeTopic(email, topic);
      setStatus({ kind: 'success', msg: `Subscribed to ${topic}` });
      try { amplitude.track('Subscribe Topic', { topic, email }); } catch {}
    } catch (e) { setStatus({ kind: 'error', msg: String(e) }); }
  };

  const handleBack = () => nav('/posts');

  return (
    <Grid fullWidth>
      <Column lg={16} md={8} sm={4}>
        {/* Top breadcrumbs + back */}
        <TopicBreadcrumbs topic={topic} onBack={handleBack} />

        <h3 style={{ marginBottom: 12 }}>{topic.replace(/-/g,' ')} — Posts</h3>

        <div style={{display:'flex', gap:12, alignItems:'flex-end', margin:'16px 0'}}>
          <TextInput
            id="sub-topic-email"
            labelText={`Weekly digest for "${topic}"`}
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            placeholder="you@example.com"
          />
          <Button onClick={onSubscribe}>Subscribe</Button>
        </div>
        {status && (
          <InlineNotification
            lowContrast
            title={status.msg}
            kind={status.kind}
            onCloseButtonClick={()=>setStatus(null)}
          />
        )}

        <div
          style={{
            display:'grid',
            gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))',
            gap:16
          }}
        >
          {posts.map(p => (
            <Card
              key={p.key}
              post={p}
              onOpen={() => {
                try { amplitude.track('Open Post', { topic, date: p.date, model: p.model }); } catch {}
                nav(`/posts/${p.topic}/${p.date}/${p.title_slug}`);
              }}
            />
          ))}
        </div>
      </Column>
    </Grid>
  );
};

export default AIPostsTopicPage;
